import { useEffect, useState } from 'react';
import { Moon } from 'lucide-react';
import { themeTranslations } from '../utils/translations';

const query = '(prefers-color-scheme: dark)';
const explicitTheme = () => document.documentElement.getAttribute('data-theme');
const isDark = () => explicitTheme() === 'dark' || (explicitTheme() !== 'light' && (window.matchMedia?.(query)?.matches ?? false));

/** Koordinationsentscheid 30.10. (#750): selection lasts until reload; CLAUDE.md forbids web localStorage/sessionStorage. */
export function ThemeToggle() {
  const [dark, setDark] = useState(isDark);
  useEffect(() => {
    const media = window.matchMedia?.(query);
    const changed = () => setDark(isDark());
    changed();
    media?.addEventListener('change', changed);
    return () => media?.removeEventListener('change', changed);
  }, []);
  const label = themeTranslations.de.darkMode;
  return <button type="button" aria-label={label} title={label} aria-pressed={dark}
    className="rounded-ctl p-1.5 text-muted hover:bg-line-2" onClick={() => {
      const next = !isDark();
      document.documentElement.dataset.theme = next ? 'dark' : 'light';
      setDark(next);
    }}><Moon size={16} strokeWidth={1.75} aria-hidden="true" /></button>;
}
